<template>
  <page>
    <lazy-div :load="doInit">
      <!-- <lazy-div> -->
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="query"></v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="query"
            >Miscellaneous Accounts Parameters
            <v-btn text color="primary" @click="queryModeSwitch" v-if="query">
              Edit
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title v-else>Miscellaneous Accounts Parameters </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.glSys"
                  :items="glSysList"
                  v-model="miscAcctForm.glSys"
                  item-text="label"
                  item-value="value"
                  data-vv-name="glSys"
                  :data-vv-as="labels.glSys"
                  :error-messages="errors.collect('glSys')"
                  v-validate="'required|param'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defIlnrcpt"
                  :items="defILNList"
                  v-model="miscAcctForm.defIlnrcpt"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defIlnrcpt"
                  :data-vv-as="labels.defIlnrcpt"
                  :error-messages="errors.collect('defIlnrcpt')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defIlnpv"
                  :items="defILNList"
                  v-model="miscAcctForm.defIlnpv"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defIlnpv"
                  :data-vv-as="labels.defIlnpv"
                  :error-messages="errors.collect('defIlnpv')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defIlncr"
                  :items="defILNList"
                  v-model="miscAcctForm.defIlncr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defIlncr"
                  :data-vv-as="labels.defIlncr"
                  :error-messages="errors.collect('defIlncr')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defIlndr"
                  :items="defILNList"
                  v-model="miscAcctForm.defIlndr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defIlndr"
                  :data-vv-as="labels.defIlndr"
                  :error-messages="errors.collect('defIlndr')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defStmtType"
                  :items="defStmtTypeList"
                  v-model="miscAcctForm.defStmtType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defStmtType"
                  :data-vv-as="labels.defStmtType"
                  :error-messages="errors.collect('defStmtType')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :label="labels.defMchOn"
                  :items="defMchOnList"
                  v-model="miscAcctForm.defMchOn"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defMchOn"
                  :data-vv-as="labels.defMchOn"
                  :error-messages="errors.collect('defMchOn')"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.cheqNoForm"
                  v-model="miscAcctForm.cheqNoForm"
                  :error-messages="errors.collect('cheqNoForm')"
                  v-validate="'integer|max:2'"
                  data-vv-name="cheqNoForm"
                  :data-vv-as="labels.cheqNoForm"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.deptMand"
                  v-model="miscAcctForm.deptMand"
                  :error-messages="errors.collect('deptMand')"
                  data-vv-name="deptMand"
                  :data-vv-as="labels.deptMand"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.multiFundSfxCurr"
                  v-model="miscAcctForm.multiFundSfxCurr"
                  :error-messages="errors.collect('multiFundSfxCurr')"
                  data-vv-name="multiFundSfxCurr"
                  :data-vv-as="labels.multiFundSfxCurr"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <!-- <v-flex xs6>
                <v-checkbox
                  :label="labels.postFirstInstalDate"
                  v-model="miscAcctForm.postFirstInstalDate"
                  :error-messages="errors.collect('postFirstInstalDate')"
                  data-vv-name="postFirstInstalDate"
                  :data-vv-as="labels.postFirstInstalDate"
                  :disabled="query"
                ></v-checkbox>
              </v-flex> -->
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtMultiAcctR"
                  v-model="miscAcctForm.prtMultiAcctR"
                  :error-messages="errors.collect('prtMultiAcctR')"
                  data-vv-name="prtMultiAcctR"
                  :data-vv-as="labels.prtMultiAcctR"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.prtMultiAcctP"
                  v-model="miscAcctForm.prtMultiAcctP"
                  :error-messages="errors.collect('prtMultiAcctP')"
                  data-vv-name="prtMultiAcctP"
                  :data-vv-as="labels.prtMultiAcctP"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.paytBlkGstinExp"
                  v-model="miscAcctForm.paytBlkGstinExp"
                  :error-messages="errors.collect('paytBlkGstinExp')"
                  data-vv-name="paytBlkGstinExp"
                  :data-vv-as="labels.paytBlkGstinExp"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-divider class="pt-3"></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ miscAcctForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscAcctForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ miscAcctForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscAcctForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!query">
          <v-btn color="error" @click="queryModeSwitch" :loading="submitting"> Cancel<v-icon right dark>mdi-cancel</v-icon> </v-btn>
          <v-btn color="primary" dark @click="doSave" :loading="submitting"> Save Parameters<v-icon right>mdi-content-save</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        glSys: 'GL System',
        defIlnrcpt: 'Default Print value for Receipt',
        defIlnpv: 'Default Print value for Payment',
        defIlncr: 'Default Print value for Credit Note',
        defIlndr: 'Default Print value for Debit Note',
        defStmtType: 'Default Statement Type',
        defMchOn: 'Default Match on value',
        cheqNoForm: 'Cheque No. Format',
        deptMand: 'Make Department mandatory in Debtor transactions',
        multiFundSfxCurr: 'Can match transactions with different funds / suffix / currency',
        postFirstInstalDate: 'Post all instalments using First Instalment date',
        prtMultiAcctR: 'Print multiple accounts in one Receipt',
        prtMultiAcctP: 'Print multiple accounts in one Payment',
        paytBlkGstinExp: 'Payment Block GST Input Tax As Expenses',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      miscAcctForm: {
        glSys: null,
        defIlnrcpt: null,
        defIlnpv: null,
        defIlncr: null,
        defIlndr: null,
        defStmtType: null,
        defMchOn: null,
        cheqNoForm: null,
        deptMand: null,
        multiFundSfxCurr: null,
        postFirstInstalDate: null,
        prtMultiAcctR: null,
        prtMultiAcctP: null,
        paytBlkGstinExp: null,
        createdBy: '',
        createdDate: '',
        modifiedBy: this.$store.state.token.firstName,
        modifiedDate: new Date()
      },
      tempStorage: [],
      glSysList: [
        { label: '1 - Odyssey', value: 1 },
        { label: '2 - SUNGL', value: 2 },
        { label: '3 - Great Plains', value: 3 }
      ],
      defILNList: [
        { label: 'Immediate', value: 'I' },
        { label: 'Later', value: 'L' },
        { label: 'No', value: 'N' }
      ],
      defStmtTypeList: [
        { label: 'Open Item', value: 'O' },
        { label: 'Brought Forward', value: 'B' },
        { label: 'Hybrid', value: 'H' }
      ],
      defMchOnList: [
        { label: 'Gross', value: 'G' },
        { label: 'Net', value: 'N' }
      ],
      submitting: false,
      query: true
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getMiscAcctParam
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.miscAcctForm.glSys = data.miscAcctParam.glSys
            this.miscAcctForm.defIlnrcpt = data.miscAcctParam.defIlnrcpt
            this.miscAcctForm.defIlnpv = data.miscAcctParam.defIlnpv
            this.miscAcctForm.defIlncr = data.miscAcctParam.defIlncr
            this.miscAcctForm.defIlndr = data.miscAcctParam.defIlndr
            this.miscAcctForm.defStmtType = data.miscAcctParam.defStmtType
            this.miscAcctForm.defMchOn = data.miscAcctParam.defMchOn
            this.miscAcctForm.cheqNoForm = data.miscAcctParam.cheqNoForm
            this.miscAcctForm.deptMand = data.miscAcctParam.deptMand
            this.miscAcctForm.multiFundSfxCurr = data.miscAcctParam.multiFundSfxCurr
            this.miscAcctForm.postFirstInstalDate = data.miscAcctParam.postFirstInstalDate
            this.miscAcctForm.prtMultiAcctR = data.miscAcctParam.prtMultiAcctR
            this.miscAcctForm.prtMultiAcctP = data.miscAcctParam.prtMultiAcctP
            this.miscAcctForm.paytBlkGstinExp = data.miscAcctParam.paytBlkGstinExp
            this.miscAcctForm.createdBy = data.createdBy
            this.miscAcctForm.createdDate = data.createdDate
            this.miscAcctForm.modifiedBy = data.modifiedBy
            this.miscAcctForm.modifiedDate = data.modifiedDate
          }
          this.tempStorage = clone(this.miscAcctForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const apiURI = this.menu.saveMiscAcctParam
          if (apiURI) {
            this.$http
              .post(apiURI, this.miscAcctForm)
              .then((result) => {
                const { data } = result
                if (data) {
                  this.notify(data)
                  this.doInit()
                }
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async queryModeSwitch() {
      if (this.query === false) {
        this.toggleToTempStorage()
        this.query = true
      } else {
        this.query = false
      }
    },
    async toggleToTempStorage() {
      this.miscAcctForm = this.tempStorage
      this.doInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.miscParams.menu
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
